import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Bars } from "@/components/site/Trabajo";
import { useApi, Status } from "./useApi";
import { Dialog } from "./Fichas";
import { IABorrador } from "./IA";

const SK = ["inicio", "central", "cierre", "tarea", "evaluacion"];
const planToText = (v) => (Array.isArray(v) ? v.map((h) => `Habilidad: ${h.habilidad}\n${(h.sesiones || []).map((s) => `Sesión ${s.n}: ${s.actividad}`).join("\n")}`).join("\n\n") : v || "");
const textToPlan = (txt) => {
  const hs = [];
  let cur = null;
  String(txt || "").split("\n").forEach((l) => {
    let m = l.match(/^habilidad\s*\d*\s*:?\s*(.+)/i);
    if (m) { cur = { habilidad: m[1], sesiones: [] }; hs.push(cur); return; }
    m = l.match(/^sesi[oó]n\s*(\d+)\s*:?\s*(.+)/i);
    if (m && cur) cur.sesiones.push({ n: m[1], actividad: m[2] });
  });
  return hs;
};

const Sesiones = ({ value, set }) => {
  const rows = Array.isArray(value) && value.length ? value : [{ n: "1" }];
  const upd = (i, k, v) => set(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  return (
    <div data-testid="sesiones-editor">
      {rows.map((s, i) => (
        <div className="sesrow" key={i} style={{ marginBottom: 6 }}>
          <input value={s.n ?? i + 1} onChange={(e) => upd(i, "n", e.target.value)} placeholder="#" aria-label="Número de sesión" />
          {SK.map((k) => <textarea key={k} value={s[k] || ""} placeholder={k} onChange={(e) => upd(i, k, e.target.value)} data-testid={`sesion-${i}-${k}`} />)}
        </div>
      ))}
      <button type="button" className="chip" onClick={() => set([...rows, { n: String(rows.length + 1) }])} data-testid="sesion-add-btn">+ Agregar sesión</button>
    </div>
  );
};

const Field = ({ f, value, set, atletas }) => {
  const [k, t, l] = f;
  const tid = `campo-${k}`;
  if (t === "area") return <label>{l}<textarea value={value || ""} onChange={(e) => set(e.target.value)} data-testid={tid} /></label>;
  if (t === "num") return <label>{l}<input type="number" step="0.1" min="0" max="10" value={value ?? ""} onChange={(e) => set(e.target.value === "" ? "" : Number(e.target.value))} data-testid={tid} /></label>;
  if (t === "atleta") return (
    <label>{l}<select value={value || ""} onChange={(e) => set(e.target.value)} data-testid={tid}><option value="">Elige…</option>{(atletas || []).map((a) => <option key={a.id} value={a.id}>{a.nombre}</option>)}</select></label>
  );
  if (t.startsWith("sel:")) {
    const o = t.slice(4).split("|");
    const cur = String(value || "");
    return (
      <label>{l}<select value={cur} onChange={(e) => set(e.target.value)} data-testid={tid}><option value="">Elige…</option>{o.map((x) => <option key={x}>{x}</option>)}{cur && !o.includes(cur) && <option>{cur}</option>}</select></label>
    );
  }
  if (t === "sesiones") return <Sesiones value={value} set={set} />;
  if (t === "plan") return <label>{l}<textarea style={{ minHeight: 180 }} value={value || ""} onChange={(e) => set(e.target.value)} placeholder={"Habilidad: Atención\nSesión 1: …"} data-testid={tid} /></label>;
  return <label>{l}<input value={value ?? ""} onChange={(e) => set(e.target.value)} data-testid={tid} /></label>;
};

const Historial = ({ items }) => (
  <div className="panel noprint" style={{ marginTop: 14 }} data-testid="registro-auditoria">
    <h4>Historial de cambios ({items.length})</h4>
    {items.length === 0 && <p className="note">Sin cambios registrados en la plataforma.</p>}
    {items.map((a) => (
      <p key={a.id} className="note" style={{ margin: "0 0 6px" }}><b>{new Date(a.fecha).toLocaleString("es-CO")}</b> · {a.usuario} · {a.accion}{a.accion === "editar" && `: ${Object.keys(a.cambios || {}).join(", ") || "sin cambios"}`}</p>
    ))}
  </div>
);

const META = [["titulo", "Título", "text"], ["deporte", "Deporte", "text"], ["club", "Club", "text"], ["periodo", "Periodo", "text"], ["fecha", "Fecha", "date"]];

export const RegistroForm = ({ id, plantilla, prefill, defaults, onClose, onSaved }) => {
  const { data: tpl } = useApi("/plantillas");
  const { data: atletas } = useApi("/atletas");
  const { data: reg, error } = useApi(id ? `/registros/${id}` : "/plantillas");
  const [r, setR] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!tpl) return;
    if (!id) { setR({ plantilla, titulo: "", deporte: defaults?.deporte || "", club: "", periodo: defaults?.periodo || "", fecha: "", campos: {}, ...(prefill || {}) }); return; }
    if (reg && reg.id === id) {
      const campos = { ...(reg.campos || {}) };
      tpl[reg.plantilla]?.g.forEach((g) => g[1].forEach((f) => { if (f[1] === "plan") campos[f[0]] = planToText(campos[f[0]]); }));
      setR({ ...reg, campos });
    }
  }, [tpl, reg, id, plantilla, prefill, defaults]);

  if (!tpl || !r) return <Dialog onClose={onClose} testid="registro-dialog"><Status data={null} error={error} /></Dialog>;
  const t = tpl[r.plantilla];
  const c = r.campos;
  const setC = (k) => (v) => setR((prev) => {
    const nc = { ...prev.campos, [k]: v };
    if (prev.plantilla === "evaluacion" && ["P", "E", "R", "M", "A"].includes(k)) {
      const vs = ["P", "E", "R", "M", "A"].map((x) => parseFloat(nc[x]));
      if (vs.every((x) => !Number.isNaN(x))) nc.GLOBAL = Number((vs.reduce((s, x) => s + x, 0) / 5).toFixed(1));
    }
    return { ...prev, campos: nc };
  });

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    const campos = { ...c };
    t.g.forEach((g) => g[1].forEach((f) => {
      if (f[1] === "plan") campos[f[0]] = textToPlan(campos[f[0]]);
      if (f[1] === "sesiones" && Array.isArray(campos[f[0]])) campos[f[0]] = campos[f[0]].filter((s) => s.inicio || s.central || s.cierre);
    }));
    const body = { plantilla: r.plantilla, titulo: r.titulo || t.n, deporte: r.deporte || "", club: r.club || "", equipoId: r.equipoId || "", periodo: r.periodo || "", fecha: r.fecha || "", campos };
    try {
      if (id) await api.put(`/registros/${id}`, body); else await api.post("/registros", body);
      toast.success("Registro guardado");
      onSaved();
    } catch (err) { toast.error(errMsg(err)); setBusy(false); }
  };

  const del = async () => {
    if (!window.confirm("¿Eliminar este registro? Esta acción queda en la auditoría.")) return;
    try { await api.delete(`/registros/${id}`); toast.success("Registro eliminado"); onSaved(); } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <Dialog onClose={onClose} testid="registro-dialog">
      <small className="note">{t.n}{r.fuente && <> · <a href={r.fuente} target="_blank" rel="noopener noreferrer" style={{ color: "var(--sol-l)" }} data-testid="registro-fuente-link">documento original</a></>}{id && ` · ${r.completo}% completo`}{r.parcial && <> · <span className="badge y">texto parcial</span></>}</small>
      <h3 style={{ margin: "4px 0 12px" }} data-testid="registro-dialog-title">{r.titulo || t.n}</h3>
      {r.plantilla === "evaluacion" && <><Bars data={c} keys={["P", "E", "R", "M", "A", "GLOBAL", "N", "SALUD", "EST"]} testid="registro-bars" />
        <IABorrador registroId={id || ""} atletaId={c.atletaId || ""} onUse={(d) => { setR((prev) => ({ ...prev, campos: { ...prev.campos, ...d } })); toast.success("Borrador aplicado: revísalo antes de guardar"); }} /><br /></>}
      <form className="pf" onSubmit={save} data-testid="registro-form">
        <fieldset><legend>Registro</legend>
          {META.map(([k, l, ty]) => <label key={k}>{l}<input type={ty} value={r[k] || ""} onChange={(e) => setR({ ...r, [k]: e.target.value })} data-testid={`registro-${k}-input`} /></label>)}
        </fieldset>
        {t.g.map((g) => (
          <fieldset key={g[0]}><legend>{g[0]}</legend>
            {g[1].map((f) => <Field key={f[0]} f={f} value={c[f[0]]} set={setC(f[0])} atletas={atletas} />)}
          </fieldset>
        ))}
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }} className="noprint">
          <button className="btn btn-sol" type="submit" disabled={busy} data-testid="registro-save-btn">{busy ? "Guardando…" : "Guardar"}</button>
          {id && <button className="btn xbtn" type="button" onClick={del} data-testid="registro-delete-btn">Eliminar</button>}
        </div>
      </form>
      {id && <Historial items={reg.auditoria || []} />}
    </Dialog>
  );
};
